import defaultState from "./state";

const solicitudEditarCreacionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "OPEN_SOLICITUD_EDITAR_CREACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion);

      if (action.modalAction) {
        detallePrestacion.codigoPrestacionPrestador = action.detalleSolicitudSol.COD_PRESTADOR;
        detallePrestacion.tipoPrestacion = action.detalleSolicitudSol.TIPO_PRESTACION;
        detallePrestacion.pabellonPrestacion = action.detalleSolicitudSol.GUARISMO;
        detallePrestacion.glosaPrestacionPrestador = action.detalleSolicitudSol.GLOSA_CODPRESTADOR;
        detallePrestacion.inicioVigenciaArancel = action.detalleSolicitudSol.INICIO_VIG;
        detallePrestacion.pertenenciaFonasa = action.detalleSolicitudSol.PERTENENCIA_FONASA;
        detallePrestacion.codigoFonasa = action.detalleSolicitudSol.CODIGO_FONASA;
        detallePrestacion.itemImed = action.detalleSolicitudSol.ITEM_IMED;
        detallePrestacion.tipoProfesional = action.detalleSolicitudSol.PROF_CCOD;
        detallePrestacion.tipoUnidad = action.detalleSolicitudSol.UNIDAD;
        detallePrestacion.montoArancelPrestacion = action.detalleSolicitudSol.VALOR;
        detallePrestacion.tipoAtencion = action.detalleSolicitudSol.TIPO_ATENCION;
        detallePrestacion.glosaTipoArancel = action.detalleSolicitudSol.ARANCEL;
        detallePrestacion.glosaCentroAtencion = action.detalleSolicitudSol.CENTRO_AT;
        detallePrestacion.rowGuid = action.detalleSolicitudSol.GUID;
      } else {
        detallePrestacion.codigoPrestacionPrestador = null;
        detallePrestacion.tipoPrestacion = null;
        detallePrestacion.pabellonPrestacion = null;
        detallePrestacion.glosaPrestacionPrestador = null;
        detallePrestacion.inicioVigenciaArancel = null;
        detallePrestacion.pertenenciaFonasa = null;
        detallePrestacion.codigoFonasa = null;
        detallePrestacion.itemImed = null;
        detallePrestacion.tipoProfesional = null;
        detallePrestacion.tipoUnidad = null;
        detallePrestacion.montoArancelPrestacion = null;
        detallePrestacion.tipoAtencion = null;
        detallePrestacion.glosaTipoArancel = null;
        detallePrestacion.glosaCentroAtencion = null;
        detallePrestacion.rowGuid = null;
      }
      return Object.assign({}, state, {
        modalSolicitudEditarCreacion: action.modalAction,
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_MONTO_ARANCEL_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        montoArancelPrestacion: action.montoArancelPrestacion,
        montoArancelPrestacionErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_TIPO_UNIDAD": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        tipoUnidad: action.tipoUnidad,
        montoArancelPrestacionErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_CODIGO_PRESTACION_PRESTADOR": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoPrestacionPrestador: action.codigoPrestacionPrestador,
        codigoPrestacionPrestadorErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_PABELLON_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        pabellonPrestacion: action.pabellonPrestacion,
        pabellonPrestacionErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_GLOSA_PRESTACION_PRESTADOR": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        glosaPrestacionPrestador: action.glosaPrestacionPrestador,
        glosaPrestacionPrestadorErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasa: action.codigoFonasa,
        codigoFonasaErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_ITEM_IMED": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        itemImed: action.itemImed,
        itemImedErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_TIPO_PROFESIONAL": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        tipoProfesional: action.tipoProfesional,
        tipoProfesionalErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_INICIO_VIGENCIA_ARANCEL": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        inicioVigenciaArancel: action.inicioVigenciaArancel,
        inicioVigenciaArancelErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_TIPO_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        tipoPrestacion: action.tipoPrestacion,
        tipoPrestacionErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CAMBIAR_PERMANENCIA_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        pertenenciaFonasa: action.pertenenciaFonasa,
        pertenenciaFonasaErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/LOADING_VALIDACION_CODIGO_FONASA": {
      return Object.assign({}, state, {
        codigoFonasaLoading: action.isLoad,
      });
    }

    case "SOLEDIT_CREACION/VALIDAR_GUARISMO": {
      return Object.assign({}, state, {
        validarGuarismo: action.validar,
      });
    }

    case "SOLEDIT_CREACION/SET_VALIDACION_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasaValid: action.valid,
        codigoFonasaErr: !action.valid ? "Código no es válido" : "",
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "SOLEDIT_CREACION/CLEAR_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasaErr: null,
        codigoFonasaValid: null,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    default:
      return state;
  }
};

export default solicitudEditarCreacionReducer;
